<template>
  <div
    class="trustpilot-widget my-4"
    :data-locale="trustpilotLocale"
    :data-template-id="widgetType"
    :data-businessunit-id="TrustPilotWidgetSetup.BUSINESS_UNIT_ID"
    :data-style-height="height"
    :data-style-width="width"
    data-theme="light"
    data-font-family="Oxygen"
    data-text-color="#000226"
    :data-e2e="TrustPilotCypressAttribute.views.REVIEW_WIDGET"
  >
    <a :href="TrustPilotUrl.CLEAR_ESTATE_REVIEWS_URL" target="_blank" rel="noopener">Trustpilot</a>
  </div>
</template>

<script>
import { LoadTrustPilotWidgetMixin } from '/@/modules/trustpilot/mixins/LoadTrustPilotWidgetMixin';
import { TrustPilotCypressAttribute } from '@/modules/trustpilot/constants/TrustPilotCypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'TrustpilotWidget',
  mixins: [LoadTrustPilotWidgetMixin],
  props: {
    widgetType: {
      type: String,
      required: true
    },
    height: {
      type: String,
      default: '50px'
    },
    width: {
      type: String,
      default: '100%'
    }
  },
  static: {
    TrustPilotCypressAttribute
  }
};
</script>
